import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 8BEE5A5E-EC0A-4FC5-96BE-7F8C2A2EE52F
 * name call-merge
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/call-merge.svg
 * tags
 * - Cellphone / Phone 
 * - Arrow 
 */
export const CallMergeIcon = createSvgIcon(<><path d="M17,20.41L18.41,19L15,15.59L13.59,17M7.5,8H11V13.59L5.59,19L7,20.41L13,14.41V8H16.5L12,3.5" /></>, 'CallMergeIcon');
export default CallMergeIcon